<template>
  <section id="reviews">
    <div class="container">
      <div class="px-4 py-5 text-center googleReviewsImg"> <img
          src="https://www.rimborsoalvolo.it/cresources/outform/images/google-reviews.png" style="max-width: 100%"> </div>
      <div class="row row-cols-1 row-cols-md-3 mb-3 text-center">
        <div class="col px-4">
          <div class="">
            <div class="coverImgReview"> <img class=""
                                              src="https://www.rimborsoalvolo.it/cresources/outform/images/albi.png" alt=""> </div>
          </div>
        </div>
        <div class="col px-4">
          <div class="">
            <div class="coverImgReview"> <img class=""
                                              src="https://www.rimborsoalvolo.it/cresources/outform/images/giuseppe.png" alt=""> </div>
          </div>
        </div>
        <div class="col px-4">
          <div class="">
            <div class="coverImgReview"> <img class=""
                                              src="https://www.rimborsoalvolo.it/cresources/outform/images/stefano.png" alt=""> </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "RecensioniFB"
}
</script>
<style scoped>

</style>